

























import { defineComponent, watch, ref } from "@vue/composition-api";
export default defineComponent({
  components: {},
  props: {},
  setup(props, { root,emit }) {
    const chatValue = ref("");
    const hasInput = ref(false);
    watch(chatValue, (newValue) => {
      // 当chatValue变化时，判断其是否为空字符串
      hasInput.value = newValue.trim() !== "";
    });
    const closeChataiDrawer=()=>{
          emit('close-drawer');
      }
    return {
      chatValue,
      hasInput,
      closeChataiDrawer
    };
  },
});
